module.exports = __webpack_public_path__ + "static/media/art_gallery_screen.d21511b2.jpg";